import styled from "@emotion/styled";
import type { Publication } from "@rowan/prisma";
import { Link } from "react-router";
import { css } from "@emotion/react";
import { PublicationMoreOptions } from "../ArchivePublicationMoreOptions";
import { useConfig } from "../../hooks/useConfig";

const PublicationLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== "border",
})<{ border?: boolean }>`
  width: 160px;
  height: 240px;

  @media (max-width: ${({ theme }) => theme.breakpoints.values.xl}px) {
    width: 120px;
    height: 180px;
  }

  img {
    height: 100%;
  }
  ${(props) => !props.border || "border: 1px solid black;"}

  :hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  :active {
    transform: translateY(4px);
  }
`;

const DisabledOverlay = styled.div`
  position: absolute;
  width: 160px;
  height: 240px;

  @media (max-width: ${({ theme }) => theme.breakpoints.values.xl}px) {
    width: 120px;
    height: 180px;
  }
  top: 0;
  left: 0;
  box-shadow: inset 0 0 0 1000px rgba(235, 235, 235, 0.6);
`;

export const PublicationButton = ({
  publication,
  recentPublication,
  homeView,
  archiveView,
}: {
  homeView?: boolean;
  archiveView?: boolean;
  publication: Publication;
  recentPublication?: { title: string; location: string; publication: number };
}) => {
  const { assetBucketUrl } = useConfig();
  return (
    <div
      css={css`
        display: flex;
      `}
    >
      {publication.imageUrl ? (
        <PublicationLink
          css={css`
            ${archiveView ? "pointer-events: none;" : ""};
            position: relative;
          `}
          to={`/pub/${publication.filename}${recentPublication?.location ? `#${recentPublication.location}` : ""}`}
        >
          <img
            src={`${assetBucketUrl ?? ""}/${publication.imageUrl}`}
            title={publication.title}
            alt={publication.title}
          />
          {archiveView && <DisabledOverlay />}
        </PublicationLink>
      ) : (
        <PublicationLink
          css={css`
            ${archiveView ? "pointer-events: none;" : ""}
            position: relative;
          `}
          to={`/pub/${publication.filename}${recentPublication?.location ? `#${recentPublication?.location}` : ""}`}
          border
          title={publication.title}
        >
          {publication.title}
          {archiveView && <DisabledOverlay />}
        </PublicationLink>
      )}
      {!homeView && (
        <PublicationMoreOptions
          publication={publication}
          archiveView={archiveView}
        />
      )}
    </div>
  );
};
